module.exports = __webpack_public_path__ + "static/media/discount-tire.06c490b8.svg";